import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FaSignOutAlt } from 'react-icons/fa';
import * as Routes from '../../util/routeConstants';
import MenuLink from '../MenuLink';
import { Link } from 'react-router-dom';
import styles from './PageLinkMenu.module.scss';

class PageLinkMenu extends React.Component {
  constructor (props) {
    super(props);
    this.state = {

    };
  }

  render () {
    const pageAccess = this.props.pageAccess || {};
    const validHeaderLinks = Routes.headerLinks.filter(function (header) {
      return pageAccess[header.accessKey] && pageAccess[header.accessKey] === true;
    });
    const { validUser, activeLink, isDesktop, isMobile } = this.props;
    return (
      <>
        {validUser && activeLink &&
          <div className={classNames(
            {
              [styles.webPageOptions]: isDesktop,
              [styles.mobilePageOptions]: isMobile
            }
          )}>
            {validHeaderLinks.map(({ link, path, sublinks }, i) =>
              <div key={i} className={styles.headerItem}>
                <MenuLink text={link} to={path} sublinks={sublinks}
                  activeLink={activeLink}
                  activeMenu={this.props.activeMenu}
                  onMenuLinkClick={this.props.onLinkChange}
                  validUser={validUser}
                />
              </div>
            )}
            { validUser.includes(Routes.DASHBOARD.name) && <div className={styles.singleMenu}>
              <Link key={'dashboard-link'} to={Routes.RISK_DASHBOARD.path}
                className={classNames(styles.link, { [styles.active]: activeLink === Routes.DASHBOARD.parentKey })}
                onClick={() => this.props.onLinkChange(Routes.DASHBOARD.key)}>{Routes.DASHBOARD.link}</Link>
            </div> }

            { validUser.includes(Routes.ORDER_BOOK.name) && <div className={styles.singleMenu}>
              <Link key={'order-book-link'} to={Routes.ORDER_BOOK.path}
                className={classNames(styles.link, { [styles.active]: activeLink === Routes.ORDER_BOOK.key })}
                onClick={() => this.props.onLinkChange(Routes.ORDER_BOOK.key)}>{Routes.ORDER_BOOK.link}</Link>
            </div> }

            <div className={styles.singleMenu}>
              <a key={'hs-link'} href={'https://hs.otcmarkets.com'} target='_blank' rel='noopener noreferrer'
                className={styles.link}>HS</a>
            </div>
            <div className={styles.singleMenu}><span >
              <FaSignOutAlt className={styles.signOutElement} onClick={this.props.logout} />
            </span></div>
          </div>

        }
      </>
    );
  }
}
PageLinkMenu.propTypes = {
  /** Class name of the input, for custom designs */
  isDesktop: PropTypes.bool,
  isMobile: PropTypes.bool,
  activeLink: PropTypes.string,
  activeMenu: PropTypes.string,
  /** Object of stats */
  validUser: PropTypes.array,
  pageAccess: PropTypes.object,
  onLinkChange: PropTypes.func,
  logout: PropTypes.func
};

export default PageLinkMenu;
